module.exports = __webpack_public_path__ + "img/product1p.b1b6f9d4.png";